import {SaltusAny} from '../../utils/SaltusAny';
import {ActionType, AutoTextField} from '../AutoForm/AutoFieldNew';

export const amendReasonField: AutoTextField = {
  id: 'amendReason',
  label: 'Reason',
  initialValue: '',
  // validate: (value: string) => (!value || value === '' ? 'Required' : undefined),
  type: ActionType.text,
  multiline: true,
  charLimit: 299,
  showCounter: true,
  minRows: 4,
};

export type AtrFormActions = 'manual' | 'request' | 'curo';

export interface AtrFormValues {
  adviserId: string;
  action: AtrFormActions;
  amendedValue: number | null;
  amendReason: string | null;
}

export type getAtrSubmitHandler = (flags?: {
  action: AtrFormActions;
}) => (values: AtrFormValues) => SaltusAny;
